import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  wrapperUnitTypeSelectorSkeleton: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
  },
  containerUnitTypeSelector: {
    display: "flex",
    flexDirection: "row",
    gap: "6px",
    flexWrap: "wrap",
  },
}));
